<template>
  <div class="main-content">
    <div class="row mb-3">
      <div
        class="col-md-12"
        v-if="!filters.central_id || filters.central_id.length === 0"
      >
        <div class="alert alert-warning" role="alert">
          <strong>Atenção:</strong> Selecione uma agência para filtrar por
          convênio.
        </div>
      </div>
      <!-- <div class="col-md-3 mt-2">
        <label>Data Inicial</label>
        <input
          type="date"
          class="form-control"
          v-model="filters.opening_date"
        />
      </div>
      <div class="col-md-3 mt-2">
        <label>Data Final</label>
        <input
          type="date"
          class="form-control"
          v-model="filters.departure_from_unit"
        />
      </div> -->

      <div class="col-md-2 mt-2">
        <label for="flagUnitSelect">Agência:</label>
        <v-select
          v-model="filters.central_id"
          :options="centrals"
          :reduce="(central) => central.id"
          label="fantasy_name"
          multiple
          placeholder="Exibir Todos"
          @input="
            getUnits();
            getMedicals();
          "
        ></v-select>
      </div>
      <div class="col-md-2 mt-2">
        <label for="flagUnitSelect">Serviço:</label>
        <v-select
          v-model="filters.occurrence_type"
          :options="[{ value: 'APH', label: 'APH' }]"
          :reduce="(option) => option.value"
          label="label"
          multiple
          placeholder="Exibir APH"
        ></v-select>
      </div>
      <div
        class="col-md-2 mt-2"
        v-if="filters.central_id && filters.central_id.length > 0"
      >
        <label for="flagUnitSelect">Convênio:</label>
        <v-select
          v-model="filters.health_plan"
          :options="plans"
          :reduce="(plan) => plan.id"
          label="title"
          multiple
          placeholder="Exibir Todos"
        ></v-select>
      </div>
      <div class="col-md-2 mt-2">
        <label>Nº Ocorrência</label>
        <input type="text" class="form-control" v-model="filters.external_id" />
      </div>
      <div class="col-md-4 mt-2">
        <label>Vitima</label>
        <input type="text" class="form-control" v-model="filters.name" />
      </div>

      <div class="col-md-4 mt-2">
        <label for="Cellphone">Unidade:</label>
        <v-select
          v-model="filters.origin"
          :options="filteredUnits"
          :reduce="(unit) => unit.id"
          label="unit_name"
          multiple
          placeholder="Exibir Todos"
        ></v-select>
      </div>

      <div class="row mt-3">
        <div class="col-md-2">
          <button class="btn btn-primary" @click="getOccurrences">
            Filtrar
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card p-1">
          <div class="table-responsive">
            <table class="table table-bordered table-hover table-sm">
              <thead>
                <tr>
                  <th></th>
                  <th>Nº Ocorrência</th>
                  <th>Agência</th>
                  <th>Serviço</th>
                  <th>Unidade (Destino)</th>
                  <th>Tipo</th>
                  <th>Motivo</th>
                  <th>Nome</th>
                  <th>Idade</th>
                  <th>Sexo</th>
                  <th>Município</th>
                  <th>Veículo</th>
                  <th>Data Abertura</th>
                  <th>Data Previsão Chegada (Destino)</th>
                  <th>Convênio</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="occurrence in occurrences" :key="occurrence.id">
                  <td>
                    <span :title="occurrence.classification">
                      {{ occurrence.classification_f }}
                    </span>
                  </td>
                  <td>{{ occurrence.external_id }}</td>
                  <td>
                    {{
                      occurrence.agency ? occurrence.agency.fantasy_name : ""
                    }}
                  </td>
                  <td>{{ occurrence.occurrence_type }}</td>
                  <td>
                    {{ occurrence.unit ? occurrence.unit.unit_name : "" }}
                  </td>
                  <td>{{ occurrence.type ? occurrence.type.title : (occurrence.central_id == 7 ? occurrence.occurrence_type_external : "") }}</td>
                  <td>
                    {{ occurrence.reason ? occurrence.reason.title : (occurrence.central_id == 7 ? occurrence.complaint : "") }}
                  </td>
                  <td>
                    {{ occurrence.people ? occurrence.people.name : "" }}
                  </td>
                  <td>
                    {{
                      occurrence.people ? occurrence.people.age + " ano(s)" : ""
                    }}
                  </td>
                  <td>
                    {{ occurrence.people ? occurrence.people.gender : "" }}
                  </td>
                  <td>{{ occurrence.people ? occurrence.people.city : "" }}</td>
                  <!-- <td v-if="occurrence.central_id == 7">
                    {{ occurrence.team ? occurrence.team.name : "" }}
                  </td> -->
                  <td>
                    {{ occurrence.vehicle ? occurrence.vehicle : "" }}
                  </td>
                  <td>{{ occurrence.opening_date_h }}</td>
                  <td>
                    {{
                      occurrence.estimated_arrival
                        ? occurrence.estimated_arrival_f
                        : "Não informado"
                    }}
                  </td>
                  <td>{{ occurrence.plan ? occurrence.plan.title : "" }}</td>

                  <td class="text-center align-middle">
                    <div
                      class="d-flex justify-content-center align-items-center"
                      style="gap: 4px"
                    >
                      <button
                        type="button"
                        class="btn btn-outline-primary btn-sm d-flex align-items-center"
                        @click="openModal(occurrence.id)"
                        title="Ver detalhes"
                      >
                        <i class="fas fa-eye"></i>
                      </button>
                      <a
                        :href="
                          occurrence.agency.flag_record === 1
                            ? occurrence.url_record
                            : occurrence.url
                        "
                        target="_blank"
                        class="btn btn-outline-primary btn-sm d-flex align-items-center"
                        title="Ver ficha"
                      >
                        <feather-icon icon="FileTextIcon" />
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div
            class="col-md-6 mt-1 mx-auto d-flex justify-content-center align-items-center"
          >
            <pagination
              :records="total"
              :options="options"
              :per-page="15"
              @paginate="getOccurrences"
            ></pagination>
          </div>
          <!-- Modal Infos -->
          <b-modal
            id="modalInfo"
            title="Informações"
            centered
            size="xl"
            dialog-class="modal-xxl"
          >
            <div v-if="occurrenceSelected">
              <div class="table-responsive">
                <table class="table table-striped text-center">
                  <thead>
                    <tr>
                      <th>Agência</th>
                      <th>Serviço</th>
                      <th>Nº Ocorrência</th>
                      <th>Data Abertura</th>
                      <th>Nome</th>
                      <th>Idade</th>
                      <th>Queixa</th>
                      <th>Tipo</th>
                      <th>Motivo</th>
                      <th>Bairro</th>
                      <th>Município</th>
                      <th>Veículo</th>
                      <th>Unidade (Destino)</th>
                      <th>Convênio</th>
                      <th>Saída do local</th>
                      <th>Chegada à Unidade (Destino)</th>
                      <th>Saída da Unidade</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        {{
                          occurrenceSelected.agency
                            ? occurrenceSelected.agency.fantasy_name
                            : ""
                        }}
                      </td>
                      <td>{{ occurrenceSelected.occurrence_type }}</td>
                      <td>{{ occurrenceSelected.external_id }}</td>
                      <td>{{ occurrenceSelected.opening_date_h }}</td>
                      <td>
                        {{
                          occurrenceSelected.people
                            ? occurrenceSelected.people.name
                            : ""
                        }}
                      </td>
                      <td>
                        {{
                          occurrenceSelected.people
                            ? occurrenceSelected.people.age
                            : ""
                        }}
                      </td>
                      <td>{{ occurrenceSelected.complaint }}</td>
                      <td>
                        {{
                          occurrenceSelected.type
                            ? occurrenceSelected.type.title
                            : (occurrenceSelected.central_id == 7 ? occurrenceSelected.occurrence_type_external : "")
                        }}
                      </td>
                      <td>
                        {{
                          occurrenceSelected.reason
                            ? occurrenceSelected.reason.title
                            : (occurrenceSelected.central_id == 7 ? occurrenceSelected.complaint : "")
                        }}
                      </td>
                      <td>
                        {{
                          occurrenceSelected.people
                            ? occurrenceSelected.people.neighborhood
                            : ""
                        }}
                      </td>
                      <td>
                        {{
                          occurrenceSelected.people
                            ? occurrenceSelected.people.city
                            : ""
                        }}
                      </td>
                      <td>{{ occurrenceSelected.vehicle }}</td>
                      <td>
                        {{
                          occurrenceSelected.unit
                            ? occurrenceSelected.unit.unit_name
                            : ""
                        }}
                      </td>
                      <td>
                        {{
                          occurrenceSelected.plan
                            ? occurrenceSelected.plan.title
                            : ""
                        }}
                      </td>
                      <td>
                        {{
                          occurrenceSelected.departure_from_unit
                            ? occurrenceSelected.departure_from_unit_f
                            : "Não informado"
                        }}
                      </td>
                      <td>
                        {{
                          occurrenceSelected.arrival_at_unit
                            ? occurrenceSelected.arrival_at_unit_f
                            : "Não informado"
                        }}
                      </td>
                      <td>
                        {{
                          occurrenceSelected.output_unit
                            ? occurrenceSelected.output_unit_f
                            : "Não informado"
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-if="!occurrenceSelected">Carregando...</div>

            <template #modal-footer>
              <b-button variant="secondary" @click="closeModal"
                >Fechar</b-button
              >
            </template>
          </b-modal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Pagination } from "vue-pagination-2";
import {
  BLink,
  BNavbarNav,
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
  BButton,
  BModal,
} from "bootstrap-vue";
export default {
  data() {
    return {
      filters: {
        central_id: [],
        health_plan: [],
        occurrence_type: ["APH"],
        origin: [],
      },
      occurrences: [],
      units: [],
      options: {
        texts: {
          count: "Mostrando {from} de {to} até {count} de registros",
        },
        chunk: 4,
        chunksNavigation: "fixed",
      },
      total: 0,
      page: 1,
      pages: [],
      selectedOccurrenceId: 2203190496,
      occurrenceSelectedId: null,
      occurrenceSelected: null,
      centrals: [],
      plans: [],
    };
  },
  components: {
    Pagination,
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    BButton,
    BModal,
  },
  watch: {
    selectedOccurrenceId: {
      handler(val) {
        if (val) {
          console.log("entrou", val);
          window.Echo.private("new_status." + val).listen(".Status", (e) => {
            console.log("ewerwerwerwe", val);
            const index = this.occurrences.findIndex(
              (o) => o.external_id === e.occurrence.external_id
            );
            console.log("entrou2", val);
            this.occurrences[index].status = e.occurrence.status;
          });
        }
      },
      immediate: true,
    },
  },
  computed: {
    filteredUnits() {
      const allOption = [{ id: null, unit_name: "Exibir Todos" }];
      if (!this.filters.central_id || this.filters.central_id.length === 0) {
        return allOption.concat(this.units);
      }
      const filtered = this.units.filter((unit) => {
        // Verifica se a unidade tem alguma das centrais no array central_names
        if (!unit.central_names) return false;
        const unitCentrals = unit.central_names.split(", "); // Como o central_names é uma string separada por vírgula
        return unitCentrals.some((central) => {
          const centralObj = this.centrals.find(
            (c) => c.fantasy_name === central
          );
          return centralObj && this.filters.central_id.includes(centralObj.id);
        });
      });
      return allOption.concat(filtered);
    },
  },
  methods: {
    openModal(occurrenceId) {
      this.occurrenceSelected = this.occurrences.find(
        (o) => o.id === occurrenceId
      );
      this.$bvModal.show("modalInfo");
    },
    closeModal() {
      this.$bvModal.hide("modalInfo");
    },
    getOccurrences(page) {
      const self = this;
      self.page = page || 1;

      const api =
        self.$store.state.api + "occurrences_progress?page=" + self.page;

      self.$loading(true);
      axios
        .post(api, self.filters)
        .then((response) => {
          self.occurrences = response.data.data;
          self.total = response.data.total;

          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.$loading(false);
        });
    },
    getUnits: function () {
      const self = this;
      let api = self.$store.state.api + "units/filter-by-central";

      if (self.filters.central_id) {
        api += `?central_ids=${self.filters.central_id}`;
      }

      axios
        .get(api)
        .then((response) => {
          self.units = response.data.data.sort((a, b) =>
            a.unit_name.localeCompare(b.unit_name)
          );
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getCentrals: function () {
      const self = this;
      const api = self.$store.state.api + "centrals?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.centrals = response.data.data.sort((a, b) =>
            a.name.localeCompare(b.name)
          );
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getMedicals: function () {
      const self = this;
      let api = self.$store.state.api + "medical-agreements?paginated=false";

      if (self.filters.central_id && self.filters.central_id.length > 0) {
        api += `&central_id=${self.filters.central_id.join(",")}`;
      }

      axios
        .get(api)
        .then((response) => {
          // Filtrar duplicatas por title (exibir apenas o primeiro de cada)
          const uniquePlans = response.data.data.filter(
            (plan, index, self) =>
              index === self.findIndex((p) => p.title === plan.title)
          );
          self.plans = uniquePlans.sort((a, b) =>
            a.title.localeCompare(b.title)
          );
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted() {
    this.getOccurrences();
    this.getUnits();
    this.getCentrals();
    this.getMedicals();

    if (this.selectedOccurrenceId) {
      window.Echo.private("new_status." + this.selectedOccurrenceId).listen(
        ".Status",
        (e) => {
          console.log("Evento recebido:", e);
        }
      );
    }

    // window.Echo.channel("new_occurrence").listen(".NewOccurrence", (e) => {
    //   console.log("Nova ocorrência pública recebida:", e);
    //   this.occurrences.unshift(e.occurrence);
    //   this.$message(null, "Nova ocorrência recebida!", "info");

    //   this.playSound();
    // });
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}

.main-content {
  padding: 20px;
}

.table th,
.table td {
  text-align: center;
}
</style>
